<template>
  <CTABottomBar
    use-chat-label
    hide-bottom-sheet-tel
    custom-facebook-icon="fa-brands fa-square-facebook"
    custom-footer-class="default-cta-footer"
    custom-padding="tw-gap-4 tw-p-4 tw-h-[80px] tw-items-center"
    custom-button-class="!tw-h-12 !tw-py-3 !tw-px-5"
    custom-button-text-class="tw-text-dt-button"
    custom-icon-size="17px"
    custom-icon-class="tw-mr-1"
    custom-icon-class-social="tw-mr-3"
    bottom-sheet-class="default-cta-sheet"
    show-bottom-sheet-close
  />
</template>

<style>
.default-cta-sheet .q-bottom-sheet__item {
  justify-content: center !important;
  align-items: center !important;
  margin: 0 !important;
  margin-bottom: 8px !important;
}

.default-cta-sheet .q-bottom-sheet__item .q-item__section--avatar {
  min-width: unset !important;
  padding-right: 8px !important;
}

.default-cta-sheet .q-bottom-sheet__item .q-item__section--main {
  flex: none !important;
}

.default-cta-sheet > .q-dialog__message {
  padding: 0 0 20px 0 !important;
}

.default-cta-sheet {
  border-radius: 12px 12px 0 0 !important;
  padding: 20px 16px !important;
}

.default-cta-footer {
  border-top: none !important;
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.06) !important;
}
</style>
